export default[
    {
        path: '/pagamento/tomador/:folhar_id/:tomador_id',
        name: 'pagamento tomador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/index.vue')
    },
    // {
    //     path: '/folhar/lista',
    //     name: 'lista', 
    //     component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    // },
    // {
    //     path: '/folhar/editar/:id',
    //     name: 'lista', 
    //     component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    // },
]